export const parseResetTokenFromSearch = (search: string): string | null => {
	const token = new URLSearchParams(decodeURIComponent(search)).get('token');
	return token?.trim() ? token.trim() : null;
};

/** SuperAdmin uses company/admin reset emails (forMember=true), same as organization flow in JOC-Web. */
export const SUPER_ADMIN_RESET_PASSWORD_FOR_MEMBER = true;
